var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { SurveyQuestionDropdownBase } from "./dropdown-base";
import { SurveyQuestionTagboxItem } from "./tagbox-item";
import { TagboxFilterString } from "./tagbox-filter";
var SurveyQuestionTagbox = /** @class */ (function (_super) {
    __extends(SurveyQuestionTagbox, _super);
    function SurveyQuestionTagbox(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionTagbox.prototype.renderItem = function (key, item) {
        var renderedItem = (React.createElement(SurveyQuestionTagboxItem, { key: key, question: this.question, item: item }));
        return renderedItem;
    };
    SurveyQuestionTagbox.prototype.renderInput = function () {
        var _this = this;
        var dropdownListModel = this.dropdownListModel;
        var items = this.question.selectedChoices.map(function (choice, index) { return _this.renderItem("item" + index, choice); });
        return (React.createElement("div", { id: this.question.inputId, className: this.question.getControlClass(), tabIndex: dropdownListModel.noTabIndex ? undefined : 0, 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            disabled: this.question.isInputReadOnly, required: this.question.isRequired, onKeyDown: this.keyhandler, onBlur: this.blur, role: dropdownListModel.ariaQuestionRole, "aria-required": dropdownListModel.ariaQuestionRequired, "aria-invalid": dropdownListModel.ariaQuestionInvalid, "aria-errormessage": dropdownListModel.ariaQuestionErrorMessage, "aria-label": dropdownListModel.ariaQuestionLabel, "aria-labelledby": dropdownListModel.ariaQuestionLabelledby, "aria-describedby": dropdownListModel.ariaQuestionDescribedby, "aria-expanded": dropdownListModel.ariaQuestionExpanded, "aria-controls": dropdownListModel.ariaQuestionControls, "aria-activedescendant": dropdownListModel.ariaQuestionActivedescendant, ref: function (div) { return (_this.setControl(div)); } },
            React.createElement("div", { className: this.question.cssClasses.controlValue },
                items,
                dropdownListModel.needRenderInput ? React.createElement(TagboxFilterString, { model: dropdownListModel, question: this.question }) : null),
            this.renderEditorButtons()));
    };
    SurveyQuestionTagbox.prototype.renderElement = function () {
        var cssClasses = this.question.cssClasses;
        var comment = this.renderOther(this.question.otherItem, cssClasses);
        var select = this.renderSelect(cssClasses);
        return (React.createElement("div", { className: this.question.renderCssRoot },
            select,
            comment));
    };
    return SurveyQuestionTagbox;
}(SurveyQuestionDropdownBase));
export { SurveyQuestionTagbox };
ReactQuestionFactory.Instance.registerQuestion("tagbox", function (props) {
    return React.createElement(SurveyQuestionTagbox, props);
});
